import { render } from "./TheModalAlert.vue?vue&type=template&id=3e746516&scoped=true&lang=pug"
import script from "./TheModalAlert.vue?vue&type=script&lang=js"
export * from "./TheModalAlert.vue?vue&type=script&lang=js"

import "./TheModalAlert.vue?vue&type=style&index=0&id=3e746516&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e746516"]])

export default __exports__